<app-loader-indicator></app-loader-indicator>
<div class="reports-layout">
  <header class="reports-header">
    <app-report-header
      [generatePdf]="generatePdf"
      [configurePdf]="configurePdf"
      [isConfiguring]="isConfiguring.value"
      [oldTemplates]="(config$ | async)?.oldTemplates"
    />
  </header>

  <main class="reports-body">
    <aside *ngIf="isConfiguring.value" class="page-library-sidebar">
      <app-report-sidebar
        [pageLibrary]="pageLibrary$ | async"
        [pages]="(config$ | async)?.template?.pages || []"
        [reportConfig]="config$ | async"
        [selectedPageIndex]="selectedPageIndex"
        (pageSelected)="onPageSelected($event)"
        (pageDeleted)="deletePage($event)"
        (pageDropped)="onDrop($event.event, $event.insertIndex)"
        (pageReordered)="onPageReordered($event)"
      >
      </app-report-sidebar>
      <!-- <div class="sidebar-content">
        <app-page-library *ngIf="pageLibrary$ | async as pageLibrary" [pageLibrary]="pageLibrary"></app-page-library>
        Sidebar content will go here
      </div> -->
    </aside>

    <section class="center-column" #centerColumn>
      <div class="pages-container" [ngStyle]="getPagesContainerStyle()">
        <ng-container *ngIf="pageLibrary$ | async as pageLibrary">
          <ng-container *ngIf="config$ | async as config; else loading">
            <div class="page-add-zone" [style.width]="getDropZoneWidth()">
              <div class="add-zone-content">
                <button mat-raised-button color="primary" (click)="onInsertPage(pageLibrary, config, 0)">
                  <mat-icon>add</mat-icon>
                  Insert page here
                </button>
              </div>
            </div>

            <ng-container *ngFor="let page of config?.template?.pages; trackBy: trackByPageId; let i = index">
              <div
                class="page-wrapper"
                #pageWrapper
                [attr.data-page-index]="i"
              >
                <app-report-page
                  [page]="page"
                  [pageNumber]="i + 1"
                  [reportConfig]="config"
                  [scale]="(config$ | async)?.zoom ?? 1"
                />

                <button
                  class="delete-page-btn"
                  (click)="deletePage(i)"
                  title="Remove page"
                >
                  ×
                </button>
              </div>

              <!-- Drop zone after each page (except last) -->
              <div
                *ngIf="config?.template?.pages && i < (config?.template?.pages?.length || 0) - 1"
                class="page-add-zone"
                [style.width]="getDropZoneWidth()"
              >
                <div class="add-zone-content">
                  <button mat-raised-button color="primary" (click)="onInsertPage(pageLibrary, config, i+1)">
                    <mat-icon>add</mat-icon>
                    Insert page here
                  </button>
                </div>
              </div>
            </ng-container>

            <!-- Drop zone after last page -->
            <div *ngIf="(config?.template?.pages ?? []).length > 0" class="page-add-zone" [style.width]="getDropZoneWidth()">
              <div class="add-zone-content">
                <button mat-raised-button color="primary" (click)="onInsertPage(pageLibrary, config, config.template!.pages.length)">
                  <mat-icon>add</mat-icon>
                  Insert page here
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #loading>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
      </div>
    </section>

    <!-- Configuration Panel: [isOpen]="isConfiguring.value" -->
    <app-config-panel *ngIf="isConfiguring.value" [reportConfig]="config$ | async" [templates]="templates$ | async">
    </app-config-panel>
  </main>
</div>
